/**
 * RN 1.22 Sexo
 * Deve ter as seguintes opções: Ignorado, Masculino, Feminino.
 * Conforme cadastro da CRC.
 */

 const IGNORADO = { name: 'Indefinido', value: 'I' }
 const MASCULINO = { name: 'Masculino', value: 'M' }
 const FEMININO = { name: 'Feminino', value: 'F' }

 const SEXOS = [ IGNORADO, MASCULINO, FEMININO ]

export default SEXOS
